export default __webpack_public_path__ + "static/media/HostawayLogo.135a221d.png";